angular.module('theme').directive('campaignCodeLink', function ($cookies, $window) {
	return {
		restrict: 'A',
		scope: {
			code: '@campaignCodeLink'
		},
		link: function ($scope, $element, $attrs) {

			angular.element($element[0]).bind('click', function (event) {
				event.preventDefault();

				if($scope.code) {
					$cookies.put('campaign-code', $scope.code, {
						path: '/',
						expires: moment().add(1, 'month').toDate()
					});
					if($attrs.href) {
						$window.location.href = $attrs.href;
					}
				}
			});

		}
	};
});
